import { render, staticRenderFns } from "./AbsentUsersEmpty.vue?vue&type=template&id=478b83e7"
import script from "./AbsentUsersEmpty.vue?vue&type=script&lang=js"
export * from "./AbsentUsersEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports